import { Component, OnInit, Inject } from '@angular/core';
import { ScrollnavService } from '../../services/scrollnav.service';
import { AuthService } from '../../services/auth.service';
import { DOCUMENT, Location } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  navIsAffix: boolean;
  navbarOpen = false;
  hashLoc: string;
  locCode: string;

  constructor(private scrollserv: ScrollnavService,
              public authService: AuthService,
              @Inject(DOCUMENT) private document: Document,
              public location: Location) {
    this.getData();
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
}

// ToggleNavBar () {
//   let element: HTMLElement = document.getElementsByClassName( 'navbar-toggler' )[ 0 ] as HTMLElement;
//   if ( element.getAttribute( 'aria-expanded' ) == 'true' ) {
//       element.click();
//   }
// }

  getData() {
    this.scrollserv.scrollChange.subscribe(value => {
        this.navIsAffix = value;
        console.log(this.navIsAffix);
      });
  }

  ngOnInit() {

    const url = document.location.href;

    if (url.indexOf('pt-br') > -1) {
      this.hashLoc = '/';
      this.locCode = 'EN';
    } else {
      this.hashLoc = '/pt-br';
      this.locCode = 'PT';
    }
    console.log(this.hashLoc);
  }

}
